import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { BookCategory } from "@modules/bookCategories/types";
import { BookCategoryFormValues } from "@modules/bookCategories/validations";

import { editBookCategoryService } from "./service";
import { UseEditBookCategoryMutationOptions } from "./types";

export function useEditCategoryMutation(
  options?: UseEditBookCategoryMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<BookCategory, ApiError, { id: string; data: BookCategoryFormValues }>({
    mutationFn: ({ id, data }) => editBookCategoryService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("book_category_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
